import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import Dropdown from 'flarum/common/components/Dropdown';
import IndexPage from 'flarum/forum/components/IndexPage';
import DiscussionListState from 'flarum/forum/states/DiscussionListState';

// 使用较低的优先级（负数），确保在 flarum/tags 之后运行
app.initializers.add('laya-solved-filter', () => {
  // 在 viewItems 中添加"已解决"筛选下拉框
  extend(IndexPage.prototype, 'viewItems', function (items) {
    const currentFilter = (app.discussions as any).solvedFilter || '';
    const isSolved = currentFilter === '1';

    items.add('solvedFilter',
      m(Dropdown, {
        buttonClassName: 'Button',
        label: isSolved
          ? app.translator.trans('laya-solved-filter.forum.filter.solved')
          : app.translator.trans('laya-solved-filter.forum.filter.all'),
        accessibleToggleLabel: app.translator.trans('laya-solved-filter.forum.filter.toggle_label'),
      }, [
        m(Button, {
          icon: !isSolved ? 'fas fa-check' : true,
          onclick: () => {
            (app.discussions as any).solvedFilter = '';
            app.discussions.refresh();
          },
          active: !isSolved,
        }, app.translator.trans('laya-solved-filter.forum.filter.all')),
        m(Button, {
          icon: isSolved ? 'fas fa-check' : true,
          onclick: () => {
            (app.discussions as any).solvedFilter = '1';
            app.discussions.refresh();
          },
          active: isSolved,
        }, app.translator.trans('laya-solved-filter.forum.filter.solved')),
      ]),
      -10
    );
  });

  // 扩展 requestParams，添加已解决筛选参数
  extend(DiscussionListState.prototype, 'requestParams', function (params: any) {
    const solvedFilter = (app.discussions as any).solvedFilter;
    if (solvedFilter === '1') {
      if (!params.filter || typeof params.filter !== 'object') {
        params.filter = {};
      }
      params.filter['solved-discussions'] = 'true';
    }
  });

  // 从左侧导航栏中移除次级标签（position 为 null 的标签）
  extend(IndexPage.prototype, 'navItems', function (items) {
    // 获取所有标签
    const tags = app.store.all('tags');

    // 遍历所有标签，移除次级标签
    tags.forEach((tag: any) => {
      if (tag && typeof tag.position === 'function') {
        const pos = tag.position();
        if (pos === null || pos === undefined) {
          // 这是次级标签，从导航中移除
          const itemKey = 'tag' + tag.id();
          if (items.has(itemKey)) {
            items.remove(itemKey);
          }
        }
      }
    });

    // 移除"更多标签"链接
    if (items.has('moreTags')) {
      items.remove('moreTags');
    }
  });
}, -100); // 优先级 -100，确保在其他扩展之后运行
